/************** product images galle**********************/
document.addEventListener('DOMContentLoaded', init)
function init() {
  const imagesBlocks = document.querySelectorAll('.wd-product-images-block')
  if ( imagesBlocks.length ) {
    imagesBlocks.forEach( imagesBlock => {

      const swiper = imagesBlock.querySelector('.images-gallery-swiper2.swiper')
      if ( swiper ) {
        const thumbnailsSwiper = imagesBlock.querySelector('.images-gallery-swiper.swiper')
            const options = JSON.parse(swiper.dataset.options)

            let productImagesGallerySwiper
            if( thumbnailsSwiper ) {
              const thumbnailsOptions = JSON.parse(thumbnailsSwiper.dataset.options)
              productImagesGallerySwiper = new Swiper( thumbnailsSwiper, thumbnailsOptions )
              options.thumbs = { swiper: productImagesGallerySwiper }
            }
            let productImagesSwiper = new Swiper( swiper, options )
            productImagesGallerySwiper2Array.push( productImagesSwiper )
      }
      

    } )
  }
}
